import React from "react";
import { ArrowUpRight } from "lucide-react";

const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/sq9le7wa_IMG_5774.jpeg",
    title: "Trucking",
    subtitle: "Transport terrestre KMS",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/pob9n706_IMG_5775.jpeg",
    title: "Warehousing",
    subtitle: "Entreposage moderne sécurisé",
    span: "lg:col-span-5",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/18kkt56z_IMG_5776.jpeg",
    title: "Partenaire International",
    subtitle: "Réseau mondial · Expéditions",
    span: "lg:col-span-5",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-white py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-4">
              <span className="font-heading font-black text-sm text-[#D90429]">04</span>
              <span className="h-px flex-1 bg-[#D90429] max-w-[60px]" />
              <span className="kms-overline">Galerie</span>
            </div>
            <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A1128] leading-[1.05]">
              Au cœur des <span className="text-[#D90429]">opérations</span> portuaires.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#6B7280] text-base self-end">
            Aperçu de notre environnement quotidien : le Port Autonome d'Abidjan,
            premier hub logistique d'Afrique de l'Ouest, où KMS Service Plus
            déploie ses opérations d'avitaillement et de logistique.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 lg:grid-rows-2 gap-5 auto-rows-fr">
          {GALLERY.map((item, i) => (
            <div
              key={item.title}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden ${item.span} min-h-[260px] lg:min-h-[300px] bg-[#0A1128]`}
            >
              <img
                src={item.url}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {/* Hover overlay only */}
              <div className="absolute inset-0 bg-[#0A1128]/0 group-hover:bg-[#0A1128]/40 transition-colors duration-500" />
              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <ArrowUpRight
                  size={32}
                  className="text-white drop-shadow-lg"
                />
              </div>
              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-[#D90429] group-hover:w-full transition-all duration-500 z-10" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
